import { SendcloudRegion } from "@redotech/redo-fulfillment-rate-common/carrier-account";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { SendcloudPlatformContractSchema } from "./list-sendcloud-platform-contracts";

export const assignSendcloudContractToTeam = {
  name: "assignSendcloudContractToTeam" as const,
  input: z.object({
    teamId: z.string(),
    region: createEnum(SendcloudRegion),
    sendcloudContractId: z.number(),
    displayName: z.string().min(1),
  }),
  output: z.object({ contract: SendcloudPlatformContractSchema }),
};
